import { Injectable } from '@angular/core';
import { Clubs } from '../types/clubs';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { UserEmployeeIds } from '../types/user';

@Injectable()
export class UserExportService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public clubs(role: string) {
    let endpoint = `${role}/clubs`;
    const url = this.commonFunctionService.findApiUrl(role);
 
    return this.Api.get(endpoint, url)
        .then((data: Clubs) => data)
        .catch(error => this.Api.handleError(error).then(() => Promise.reject()));
    }

    public clubsUserList(clubId: string, role: string) {
      let endpoint = `${role}/clubs/${clubId}`;
      const url = this.commonFunctionService.findApiUrl(role);

      return this.Api.get(endpoint, url)
        .then((data: UserEmployeeIds) => data)
        .catch(error => this.Api.handleError(error).then(() => Promise.reject()));
    }

  //   public userList(role: string, PageEvent?: NgPageEvent) {
  //     let endpoint = environment.endpoint[role].exportUsers();

  //     return this.Api.getWithPageEvent(endpoint, PageEvent)
  //       .then((data: IUserExportResponseBody) => data)
  //       .catch(error => this.Api.handleError(error).then(() => Promise.reject()));
  //   }
}
